import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import usePermissions from '@/hooks/usePermissions';
const NameWithHubspotId = ({ name, hubspotId }) => {
    const { isKasmAdmin } = usePermissions();
    const showHubspotId = isKasmAdmin && !!hubspotId;
    return (_jsxs(_Fragment, { children: [!!name && (_jsx("span", { className: "ellipsis", title: name, children: name })), showHubspotId && _jsx("small", { children: hubspotId }), !name && !hubspotId && _jsx("small", { children: "-" })] }));
};
export default NameWithHubspotId;
